import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import CompanyRoleModuleTypes from '@/store/modules/middleGround/member/companyRole/interface';

const companyRoleModule: Module<CompanyRoleModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageCompanyRoleList(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pageCompanyRoleList", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listPermission(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listPermission", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveCompanyRole(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/saveCompanyRole", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listCompanyRolePerm(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listCompanyRolePerm", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        deleteCompanyRole(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/deleteCompanyRole", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
        
        
        
    },
};

export default companyRoleModule;